import { ApiMessage } from '@/api/api'
import { ApiTypingLive } from '../integrations/regru/api/api'
import { mapGetters } from 'vuex'

export default {
    data() {
        return {
            typingLiveLastSendMessage: '',
            typingLiveNewMessage: '',
            typingLiveLastMessage: '',
            typingLiveLastSend: true
        }
    },
    computed: {
        ...mapGetters('articles', ['getArticles'])
    },
    created() {},

    mounted() {},
    beforeDestroy() {},
    methods: {
        typingLiveSend() {
            if (this.typingLiveNewMessage != this.typingLiveLastSendMessage) {
                ApiMessage.typingLive(this.typingLiveNewMessage, this.$store.state.active_chat_id)
            }
        },
        typingLive(message) {
            this.$store.commit('articles/delArticles')
            this.$store.commit('articles/setShowArticles')
            this.typingLiveNewMessage = message
            // if (!this.$store.state.active_chat_id && message !== '' && message.length > 4) {
            //     if (sessionStorage.getItem('regruIntegration')) {
            //         ApiTypingLive.supportArticles({ word: this.typingLiveNewMessage })
            //             .then(response => {
            //                 response.strict_search.forEach(item => {
            //                     this.$store.commit('articles/setArticles', item)
            //                 })
            //                 this.$store.commit('articles/setShowArticles')
            //             })
            //             .catch(err => console.log(err))
            //     }
            // } else {
            //     this.$store.commit('articles/setShowArticles')
            // }

            if (message != this.typingLiveLastMessage) {
                this.typingLiveLastMessage = message

                if (this.typingLiveLastSend) {
                    this.typingLiveLastSend = false
                    setTimeout(() => {
                        this.typingLiveSend()
                        this.typingLiveLastSend = true
                    }, 3000)
                }
            }
        }
    }
}
